export default __webpack_public_path__ + "static/media/roadmap4.c2f398d2.png";